import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {
  createPromotionApi,
  deletePromotionApi,
  getPromotionApi,
  getPromotionListApi,
  updatePromotionApi,
  updatePromotionStatusApi,
} from '@src/api/promotions';
import {
  PromotionListParams,
  PromotionParams,
  PromotionStatusType,
} from '@src/api/promotions/promotions';
import { PromotionFormData } from '@src/types/promotion';

const createPromotion = createAsyncThunk(
  'promotion/create',
  async (data: PromotionFormData, { rejectWithValue }) => {
    try {
      await createPromotionApi(data);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw rejectWithValue(error.response?.data);
      }
    }
  }
);

const getPromotionList = createAsyncThunk(
  'promotion/getList',
  async (params: PromotionListParams, { rejectWithValue }) => {
    try {
      const response = await getPromotionListApi(params);
      return response.result.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const getPromotion = createAsyncThunk(
  'promotion/get',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getPromotionApi(id);
      return response.result.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const updatePromotion = createAsyncThunk(
  'promotion/update',
  async (
    { id, data }: { id: number; data: PromotionFormData },
    { rejectWithValue }
  ) => {
    try {
      await updatePromotionApi(id, data);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw rejectWithValue(error.response?.data);
      }
    }
  }
);

const updatePromotionStatus = createAsyncThunk(
  'promotion/updateStatus',
  async (
    { id, status }: { id: number; status: PromotionStatusType },
    { rejectWithValue }
  ) => {
    try {
      await updatePromotionStatusApi(id, status);
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const deletePromotion = createAsyncThunk(
  'promotion/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await deletePromotionApi(id);
      return id;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw rejectWithValue(error.response?.data);
      }
    }
  }
);

export {
  createPromotion,
  getPromotionList,
  getPromotion,
  updatePromotion,
  updatePromotionStatus,
  deletePromotion,
};
